// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"684":"4ecf317cf4f9a6ed","3185":"3c49eb0b95ffb576"}[chunkId] + ".css";
};